export default __webpack_public_path__ + "static/media/element_55.46d6820d.jpg";